import {
  Box,
  Button,
  Heading,
  Radio,
  RadioGroup,
  Text,
  TextInput,
} from '@razorpay/blade/components';
import {
  FormWrapper,
  StepActionsWrapper,
  StepContentWrapper,
} from 'components/WizardViews/components';
import { useWizardInfo } from 'components/WizardViews/providers/WizardInfoProvider';
import { useFormWithProvider } from 'forms';
import React, { FormEvent } from 'react';
import { bonusSteps, clawbackValidationSchema } from './constants';
import { BonusFormData } from './types';
import { getClawbackDeadline } from './utils';

const ClawbackRulesStep: React.FC = () => {
  const { formData, register, validate } = useFormWithProvider<BonusFormData>();
  const { updateStepStatus, setCurrentStep } = useWizardInfo();

  const clawbackDeadline = getClawbackDeadline(formData);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (validate(clawbackValidationSchema)) {
      updateStepStatus(bonusSteps.step2, 'success');
      setCurrentStep(bonusSteps.step3);
    }
  };

  return (
    <FormWrapper onSubmit={handleSubmit}>
      <StepContentWrapper noBgIllustration width="462px">
        <Box marginBottom="spacing.8" display="flex" flexDirection="column" gap="spacing.2">
          <Heading weight="semibold" color="surface.text.gray.normal" size="large">
            Add clawback rules
          </Heading>
          <Text size="medium" weight="regular" variant="body" color="surface.text.gray.muted">
            Add a clawback rule if you want to recover the paid bonus if the employee leaves before
            a certain period. The paid bonus will be recovered during full and final settlement
          </Text>
        </Box>

        <RadioGroup {...register('hasClawback', 'radiogroup')}>
          <Radio value="false">No, I don&apos;t have any clawback rule</Radio>
          <Radio value="true">Yes, I have clawback rule</Radio>
        </RadioGroup>

        {formData.hasClawback === 'true' && (
          <Box display="flex" flexDirection="column" gap="spacing.3" marginTop="spacing.7">
            <Text color="surface.text.gray.muted">
              Enter the clawback duration for the bonus. This will be effective from the payment
              date
            </Text>
            <TextInput
              label="Number of Months"
              placeholder="Enter Number of Months"
              type="number"
              {...register('clawbackMonths')}
              isRequired
            />
            {clawbackDeadline && (
              <Text size="small" color="surface.text.gray.muted">
                The bonus amount will be recovered during FnF if the employee is dismissed before{' '}
                {clawbackDeadline}
              </Text>
            )}
          </Box>
        )}
      </StepContentWrapper>
      <StepActionsWrapper width="462px">
        <Button variant="secondary" onClick={() => setCurrentStep(bonusSteps.step1)}>
          Back
        </Button>
        <Button type="submit">Next</Button>
      </StepActionsWrapper>
    </FormWrapper>
  );
};

export default ClawbackRulesStep;
